module.exports = __webpack_public_path__ + "img/favicon.5756f54d.png";